import { render, staticRenderFns } from "./barprogress.vue?vue&type=template&id=c178a89e&scoped=true&"
import script from "./barprogress.vue?vue&type=script&lang=js&"
export * from "./barprogress.vue?vue&type=script&lang=js&"
import style0 from "./barprogress.vue?vue&type=style&index=0&id=c178a89e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c178a89e",
  null
  
)

export default component.exports